'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ComponentWithBodyClass;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forEachClassName = function forEachClassName(classNames, cb) {
  classNames.trim().split(/\s+/).forEach(function (className) {
    cb(className);
  });
};
/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */
function ComponentWithBodyClass(props) {
  var bodyElement = props.bodyElement,
      bodyClassName = props.bodyClassName,
      children = props.children;


  (0, _react.useEffect)(function () {
    forEachClassName(bodyClassName, function (className) {
      bodyElement.classList.add(className);
    });
    return function () {
      forEachClassName(bodyClassName, function (className) {
        bodyElement.classList.remove(className);
      });
    };
  }, [bodyClassName, bodyElement]);

  return children;
}

ComponentWithBodyClass.propTypes = {
  bodyClassName: _propTypes2.default.string.isRequired,
  bodyElement: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node
};

ComponentWithBodyClass.defaultProps = {
  bodyElement: document.body
};

ComponentWithBodyClass.displayName = 'ComponentWithBodyClass';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/ComponentWithBodyClass.js
// module id = 195
// module chunks = 177